export default __webpack_public_path__ + "static/media/Snd_TryT.44b5af9a.mp3";